import { IconSvg, type IconSvgProps } from '../components/IconSvg';

export function MenuToggle(props: IconSvgProps) {
  return (
    <IconSvg size={30} viewBox="0 0 30 30" {...props}>
      <path d="M6.25 7.5H23.75V10H6.25V7.5ZM6.25 13.75H18.75V16.25H6.25V13.75ZM13.75 20V22.5H6.25V20H13.75Z" />
    </IconSvg>
  );
}
